import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Konfiguracja Firebase - dynamiczna domena
const getAuthDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return "losujemy.firebaseapp.com"; // Dla development
  }
  // Dla produkcji zawsze używaj losujemy.firebaseapp.com
  return "losujemy.firebaseapp.com";
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCZG2uHB2IZ__F6CxgOF2m4GhW-SafT2VM",
  authDomain: getAuthDomain(),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "losujemy",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "losujemy.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "271352474565",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:271352474565:web:7f8ea133aecf58d2eb79ac",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ZF948JXHGX"
};

console.log('🔍 Firebase authDomain:', firebaseConfig.authDomain);

// Bezpieczna inicjalizacja Firebase - sprawdź czy już istnieje
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
  console.log('🔍 Firebase app - nowa inicjalizacja:', app);
} else {
  app = getApp(); // Użyj istniejącej instancji
  console.log('🔍 Firebase app - używam istniejącej instancji:', app);
}

// Eksportuj Auth, Firestore i Google Provider
export const auth = getAuth(app);
console.log('🔍 Firebase auth zainicjalizowany:', auth);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Konfiguracja Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app; 